import { render, staticRenderFns } from "./sliderManage.vue?vue&type=template&id=0465a0a0&"
import script from "./sliderManage.vue?vue&type=script&lang=js&"
export * from "./sliderManage.vue?vue&type=script&lang=js&"
import style0 from "./sliderManage.vue?vue&type=style&index=0&id=0465a0a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports